import Vue from "vue";
import App from "./App.vue";
import Mobile from "./Mobile.vue"
import router from "./router";
import store from "./store";
import axios from "axios";
import Base64 from "js-base64";
import md5 from "js-md5";
import Cookies from "js-cookie";
import moment from "moment";
import api from "./axios/api";
import config from "./config";
import RequestPath from "./utils/RequestPath";
import ConstUtils from "@/utils/ConstUtils";
import Global from "./utils/Global";
import Vuex from "vuex";
import ElementUI from "element-ui";
import "./css/icon/iconfont.css";
import "./css/icon/iconfont.js";
// import { leStatic } from "@/libs/leStatic"
Vue.use(ElementUI);
Vue.use(Vuex);
import Video from "video.js";
import "video.js/dist/video-js.css";
import ClearMeaningConst from "@/utils/ClearMeaningConst";
//amfe-flexible 动态设置 REM 基准值(html 标签的字体大小)
import 'amfe-flexible';
import {
  getOS
} from "./utils/MobileGlobal";
import {
  Toast
} from 'vant';
Vue.use(Toast);
//执行SvgIcon的注册
import './assets/svg';

Vue.prototype.$video = Video;

// Vue.prototype.$log = leStatic;

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.$base64 = Base64.Base64;
Vue.prototype.$md5 = md5;
Vue.prototype.$cookie = Cookies;
Vue.prototype.$Global = Global;
Vue.prototype.$api = api;
Vue.prototype.moment = moment;
Vue.prototype.ConstUtils = ConstUtils;
Vue.prototype.ClearMeaningConst = ClearMeaningConst;
Vue.prototype.REQUEST_PATH = RequestPath;
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.prototype.globalWebsocketURL = "";
let platformFlag = getOS();
config
  .getConfig(process.env.NODE_ENV)
  .then(apolloConfig => {
    let webSocketURL = apolloConfig.WORK.webSocketURL;
    Vue.prototype.globalWebsocketURL = webSocketURL ?
      webSocketURL :
      "http://mx-dspt-push-ln.mxnavi.com:8987";
    // console.log(apolloConfig.WORK.webSocketURL);
    document.title =
      "鹿驾网—2020自驾游攻略|自驾游路线查询|自驾游去哪里好玩|自驾游记赚钱";
    // document.title = `首页_自驾出游好帮手_${apolloConfig.WORK.domtitle}`;
    RequestPath.setWebPath(apolloConfig.URL_SERVICE);
    RequestPath.setPath(apolloConfig.WORK.oemId, apolloConfig.WORK.appId);
    let userId = Cookies.get("userInfo_userId") || "no-user",
      userToken = Cookies.get("userInfo_token") || "no-token";
    RequestPath.webServiceInterface(
      apolloConfig.WORK.oemId,
      apolloConfig.WORK.appId,
      userId,
      userToken
    );
    RequestPath.userInformatin(
      apolloConfig.WORK.oemId,
      apolloConfig.WORK.appId,
      userId,
      userToken
    );
    RequestPath.userBehavior(
      apolloConfig.WORK.oemId,
      apolloConfig.WORK.appId,
      userId,
      userToken
    );
    Vue.prototype.apolloConfig = apolloConfig;
  })
  .catch(e => {
    // router.push({
    //   path: "/Error"
    // });
    // document.title = "出错了";
  })
  .finally(() => {
    new Vue({
      router,
      store,
      data: {
        showBottomArea: true,
        isLogin: false,
        showWriteBall: false
      },
      methods: {
        verificationLogin(flag) {
          this.isLogin = flag;
        }
      },
      render: h => h(platformFlag === 'PC' ? App : Mobile)
    }).$mount("#app");
  });
let warningShow = false;
router.beforeEach((to, from, next) => {
  let platformFlag = getOS();
  //当前为PC端
  if (platformFlag === "PC") {
    //如果是从移动端的详情页跳转到PC端的详情页
    if (to.path.indexOf("travelDetail")!== -1) {
      let travelIdArr =  to.path.split("/");
      let travelId = travelIdArr[travelIdArr.length -1];
      next({
        path: `/detail/${travelId}`
      });
    } else if (["/login", "/regist", "/forget",  "/person", "/activity", "/newTravelList", "/searchList"].includes(to.path)) {
      // 如果是从移动端的其他页跳转到PC端
      next('/')
    } else if ((to.path == "/minelog/login") | (to.path == "/minelog/register")) {
      //如果想跳转的页面是登陆和注册页面
      //并且缓冲中没有想去的页面则保存在缓存中
      if (!localStorage.getItem("intentWay")) {
        localStorage.setItem("intentPath", from.path);
      }
      localStorage.removeItem("intentWay");
      next();
    } else if (to.meta.requireAuth && !Cookies.get("userInfo_userId")) {
      //如果想跳转的页面需要权限并且用户没有登录，则记录用户想要去的页面并跳转至登录页
      if (!warningShow) {
        warningShow = true;
        ElementUI.Message({
          message: "请登录后继续操作",
          type: "warning",
          onClose: () => {
            warningShow = false;
          }
        });
      }

      localStorage.setItem("intentPath", to.path);
      localStorage.setItem("intentWay", true);
      next({
        path: "/minelog/login"
      });
    } else {
      // 
      next();
    }
  } else {
    //当前从PC端分享到移动端
    if (to.path.indexOf("detail")!== -1) {
       let travelIdArr =  to.path.split("/");
      let travelId = travelIdArr[travelIdArr.length -1];
       next({
        path: `/travelDetail/${travelId}`
      });
    } else if ( ["/", "/login", "/regist", "/forget",  "/person", "/activity", "/newTravelList", "/searchList"].includes(to.path) || to.path.indexOf("travelDetail")!== -1) {
      // 当前为移动端的其他页面则直接放行
      next();
    } else {
      // 当前为从PC端的其他页面跳转到移动端
      next({
        path: '/'
      })
    }
  }

});

router.afterEach((to, from) => {
  let titleMap = new Map([
    ["/", "鹿驾网—2020自驾游攻略|自驾游路线查询|自驾游去哪里好玩|自驾游记赚钱"],
    ["/play", "玩+专区_写自驾游记赚钱的网站_鹿驾网"],
    ["/personInfo", "个人信息_自驾出游好帮手_鹿驾网"],
    ["/minelog/login", "登录_自驾出游好帮手_鹿驾网"],
    ["/minelog/register", "注册_自驾出游好帮手_鹿驾网"],
    ["/travelAttr", "游记属性_自驾出游好帮手_鹿驾网"],
    ["/traveling/new", "游记编辑_自驾出游好帮手_鹿驾网"],
    ["/success", "游记发布_自驾出游好帮手_鹿驾网"],
    ["/mine/travel", "我的游记_自驾出游好帮手_鹿驾网"],
    ["/mine/want", "我的游记_自驾出游好帮手_鹿驾网"],
    ["/mine/comment", "我的游记_自驾出游好帮手_鹿驾网"],
    ["/about", "关于我们_自驾出游好帮手_鹿驾网"],
    ["/protocal/privacy", "隐私协议_自驾出游好帮手_鹿驾网"],
    ["/protocal/serve", "游记协议_自驾出游好帮手_鹿驾网"],
    ["/travelList", "自驾游记列表_自驾出游好帮手_鹿驾网"],
    ["/message", "消息通知_自驾出游好帮手_鹿驾网"]
  ]);
  document.title = titleMap.get(to.path) ?
    titleMap.get(to.path) :
    "自驾出游好帮手_鹿驾网"; //采用能够检索到 一个数组中的元素 再拿数组中的元素去map取值的方式
});

function setPath(productId, appId, userId) {
  RequestPath.setPath(productId, appId, userId);
}